import React, { Fragment, useEffect, useReducer,useState , useCallback, useRef } from "react";
import { Button, Dropdown, Modal, Tab, Nav,Spinner  } from "react-bootstrap";
import { Link } from "react-router-dom";
import LightGallery from 'lightgallery/react';
import ChangePassword from '../../../pages/Authentication/password/ChangePassword';
import profil from "../../../../images/profile/profile.jfif";

import 'lightgallery/css/lightgallery-bundle.css';

import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import { useDispatch, useSelector } from "react-redux";
import {UpdateUserService, UpdateUserService1} from "../../../../core/store/auth/login/thunk"
import { uploadImage } from "../../../../core/store/document/thunks"

//** Import Image */
//** Import Image */
import profile01 from "../../../../images/profile/profile001.jfif";
import profile02 from "../../../../images/profile/g6.jpg";
import profile03 from "../../../../images/profile/g5.jpg";
import profile04 from "../../../../images/profile/G4.jpg";
import profile05 from "../../../../images/profile/g3.jpg";
import profile06 from "../../../../images/profile/g2.jfif";
import profile07 from "../../../../images/profile/g1.jfif";
import profile08 from "../../../../images/profile/P08.jfif";
import profile09 from "../../../../images/profile/p09.jpg";
import profile from "../../../../images/profile/OIP (1).jfif";
import cover from "../../../../images/profile/OIP (1).jfif";
import { createSelector } from "@reduxjs/toolkit";
import { X } from "lucide-react";
import UserProfile from "../../../pages/profils/Profil";
import { GetUserServices } from "../../../../core/store/auth/login/thunk";
import PageTitle from "../../../layouts/PageTitle";


const galleryBlog = [
	{image: profile03}, {image: profile04},
	{image: profile02}, {image: profile04},
	{image: profile03}, {image: profile02},
];
const initialState = false;
const reducer = (state, action) =>{
	switch (action.type){
		case 'sendMessage':
			return { ...state, sendMessage: !state.sendMessage }		
		case 'postModal':
			return { ...state, post: !state.post }
		case 'linkModal':
			return { ...state, link: !state.link }		
		case 'cameraModal':
			return { ...state, camera: !state.camera }		
		case 'replyModal':
			return { ...state, reply: !state.reply }
		default:
			return state	
	}	
}

const AppProfile = () => {

	const [isUploading, setIsUploading] = useState(false);
	const fileInputRef = useRef(null); 
	  const [isLoading, setIsLoading] = useState(false);
	  const [showChangePassword, setShowChangePassword] = useState(false);
	  const [updateSuccess, setUpdateSuccess] = useState(false);
		const [updateError, setUpdateError] = useState(null);
		const [basicInfoSuccess, setBasicInfoSuccess] = useState(false);
const [basicInfoError, setBasicInfoError] = useState(null);
const [preferencesSuccess, setPreferencesSuccess] = useState(false);
const [preferencesError, setPreferencesError] = useState(null);
	const selectLayoutState = (state) => state;
// const loginpageData = createSelector(
// 	selectLayoutState,
// 	(state) => ({
// 		user: state.Login.user.data,
// isAuthenticated: state.Login.isAuthenticated
	  
// })
// ); 


const [state] = useReducer(reducer, initialState);
const  [user, setUser]  = useState(null);



 const dispatch = useDispatch();
 const [preferences, setPreferences] = useState([]);
 const [intolerances, setIntolerances] = useState([]);
 const [newPreference, setNewPreference] = useState("");
 const [newIntolerance, setNewIntolerance] = useState("");




 const [userData, setUserData] = useState({
	userId: "",
    firstname: "",
    lastname: "",
    dateOfBirth: "",
    gender: "MALE",
    phoneNumber: "",
    country: "",
    photo: "",
   recommandations: [],
   dc_specialization: "",
   dc_degree: "",
   dc_siretOrSiren: "",
    su_height: 0,
    su_initialWeight: 0,
    su_activityLevel: "SEDENTARY",
    su_equipmentAccess: false,
    su_dailyGoal: {
      id: 0,
      calories: 0,
      fats: 0,
      carbs: 0,
      protein: 0,
    },
    su_userGoal: {
      id: 0,
      weightGoal: {
        id: 0,
        name: "",
        description: "",
        goalType: "LOSE",
      },
      method: "DIET",
    },
    su_preferenceIds: [],
	su_preferences :[],
  });
 const [userData1, setUserData1] = useState({
	userId: "",
    firstname: "",
    lastname: "",
    phoneNumber: "",
    photo: "",
  });

  // Récupérer les données de l'utilisateur
  useEffect(() => {
	 const userId = JSON.parse(sessionStorage.getItem("authUser"))?.data?.userId;
    console.log("Dispatching GetAllDietPlanServices...", userId);
	if (!userId) return;
  
	dispatch(GetUserServices(userId)).unwrap() // ← Ajout de `.unwrap()`
	  .then((data) => {
		console.log("Données utilisateur :", data);
		setUser(data);
		//setUserData(data); 
		setUserData1({
			userId: data.userId || "",
			firstname: data.firstname || "",
			lastname: data.lastname || "",
			phoneNumber: data.phoneNumber || "",
			photo: data.photo || "",
		  });
		 setUserData({
			userId: data.userId,
      firstname: data.firstname || "",
      lastname: data.lastname || "",
      dateOfBirth: data.dateOfBirth || "",
      gender: data.gender || "MALE",
      phoneNumber: data.phoneNumber || "",
      country: data.country || "",
      photo: data.photo || "",
      recommandations: [], // 🔥 Si le backend ne fournit pas cette info, on laisse vide

      dc_specialization: "", // 🔥 Si non fourni par le backend
      dc_degree: "",
      dc_siretOrSiren: "",

      su_height: data.height || 0, // 🔥 Conversion du champ `height`
      su_initialWeight: data.standardInitialWeight || 0, // 🔥 Correction du champ `standardInitialWeight`
      su_activityLevel: data.activityLevel || "SEDENTARY",
      su_equipmentAccess: data.equipmentAccess || false,

      su_dailyGoal: {
        id: data.dailyGoal?.id || 0,
        calories: data.dailyGoal?.calories || 0,
        fats: data.dailyGoal?.fats || 0,
        carbs: data.dailyGoal?.carbs || 0,
        protein: data.dailyGoal?.protein || 0,
      },

      su_userGoal: {
        id: data.userGoal?.id || 0,
        weightGoal: {
          id: data.userGoal?.weightGoal?.id || 0,
          name: data.userGoal?.weightGoal?.name || "",
          description: data.userGoal?.weightGoal?.description || "",
          goalType: data.userGoal?.weightGoal?.goalType || "LOSE",
        },
        method: data.userGoal?.method || "DIET",
      },
	  su_preferenceIds: data.preferences?.map(pref => ({
        id: `Pref_${Date.now()}`, // 🔥 Génère un ID unique
        type: pref.type,
        name: pref.name,
        description: pref.description || "",
      })) || [],
     
    });
  
	  })
	  .catch((error) => {
		console.error("Erreur lors de la récupération des données :", error);
	  });
  }, [dispatch]);
  

   const generateUUID = () => {
    return "xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  // Charger les données existantes au montage
  useEffect(() => {
    if (userData.su_preferenceIds) {
      setPreferences(userData.su_preferenceIds.filter((pref) => pref.type === "ALIMENTARY"));
      setIntolerances(userData.su_preferenceIds.filter((pref) => pref.type === "INTOLERANCE"));
    }
  }, [userData]);

  // Ajouter une préférence
  const addPreference = () => {
    if (newPreference.trim() !== "") {
      const newPref = {
        id: generateUUID(),
        type: "ALIMENTARY",
        name: newPreference.trim(),
        description: "",
      };
      setPreferences([...preferences, newPref]);
      setNewPreference("");
    }
  };

  // Ajouter une intolérance
  const addIntolerance = () => {
    if (newIntolerance.trim() !== "") {
      const newIntol = {
        id: generateUUID(),
        type: "INTOLERANCE",
        name: newIntolerance.trim(),
        description: "",
      };
      setIntolerances([...intolerances, newIntol]);
      setNewIntolerance("");
    }
  };

  // Supprimer une préférence
  const removePreference = (id) => {
    setPreferences(preferences.filter((pref) => pref.id !== id));
  };

  // Supprimer une intolérance
  const removeIntolerance = (id) => {
    setIntolerances(intolerances.filter((intol) => intol.id !== id));
  };

  // Gestion des modifications de formulaire
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setUserData1((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
	e.preventDefault();
	setIsLoading(true);
	setBasicInfoSuccess(false);
	setBasicInfoError(null);
  
	try {
	  await new Promise(resolve => setTimeout(resolve, 1500));
	  await dispatch(UpdateUserService(userData1));
	  setBasicInfoSuccess('Les informations ont été mises à jour avec succès !');
	  
	  const userId = JSON.parse(sessionStorage.getItem("authUser"))?.data?.userId;
	  if (userId) {
		await dispatch(GetUserServices(userId));
	  }
	  
	  setTimeout(() => setBasicInfoSuccess(false), 5000);
	} catch (error) {
	  console.error("Erreur lors de la mise à jour :", error);
	  setBasicInfoError("Une erreur est survenue lors de la mise à jour. Veuillez réessayer.");
	} finally {
	  setIsLoading(false);
	}
  };
  

  const handleSubmit1 = async (e) => {
	e.preventDefault();
	setIsLoading(true);
	setPreferencesSuccess(false);
	setPreferencesError(null);
  
	try {
	  const updatedPreferences = [...preferences, ...intolerances];
	  const updatedData = {
		...userData,
		su_preferences: updatedPreferences,
	  };
  
	  await new Promise(resolve => setTimeout(resolve, 1500));
	  await dispatch(UpdateUserService1(updatedData));
	  setPreferencesSuccess('Les préférences ont été mises à jour avec succès !');
	  
	  const userId = JSON.parse(sessionStorage.getItem("authUser"))?.data?.userId;
	  if (userId) {
		const data = await dispatch(GetUserServices(userId)).unwrap();
		setUser(data);
		setUserData(data);
	  }
	  
	  setTimeout(() => setPreferencesSuccess(false), 5000);
	} catch (error) {
	  console.error("Erreur lors de la mise à jour :", error);
	  setPreferencesError("Une erreur est survenue lors de la mise à jour. Veuillez réessayer.");
	} finally {
	  setIsLoading(false);
	}
  };
  
  
  
  
  
	const onInit = () => {
		//console.log('lightGallery has been initialized');
	};
  	


	//const { uploadedImageUrl, loading, error } = useSelector((state) => state.dietPlan);
  
	// Gère la sélection de fichier
	const handleFileChange = useCallback((event) => {
		const file = event.target.files[0];
		if (file) {
		  setIsUploading(true);
	  
		  // Prévisualisation immédiate avant l'upload
		  const fileReader = new FileReader();
		  fileReader.onload = (e) => {
			setUserData((prevData) => ({
			  ...prevData,
			  photo: e.target.result, // Affiche temporairement l'image avant l'upload
			}));
		  };
		  fileReader.readAsDataURL(file);
	  
		  dispatch(uploadImage(file))
			.then((result) => {
			  if (uploadImage.fulfilled.match(result)) {
				setUserData1((prevData) => ({
				  ...prevData,
				  photo: result.payload.fileUrl, // Remplace par l'URL définitive
				}));
			  }
			})
			.catch((error) => {
			  console.error("Erreur lors de l'upload :", error);
			  alert("Erreur lors de l'upload de l'image !");
			})
			.finally(() => setIsUploading(false));
		}
	  }, [dispatch]);
	  
//	  console.log("Recommandations:", userData.recommandations);
  
  

	return (
		<Fragment>
		  <PageTitle activeMenu="Profile" motherMenu="App" />
	
		  <div className="row">
			<div className="col-lg-12">
			  <div className="profile card card-body px-3 pt-3 pb-0">
				<div className="profile-head">
				  <div className="photo-content ">
					<div className="cover-photo">
					<img src={cover} className="img-fluid rounded-circle" alt="cover"/>
					</div>
				  </div>
				  <div className="profile-info">
					<div className="profile-photo">
					  <img src={user?.photo || profil} style={{height:"150px", width:"200px"}} className="img-fluid rounded-circle" alt="profile"/>
					</div>
					<div className="profile-details">
					  <div className="profile-name px-3 pt-2">
						<h4 className="text-primary mb-0">{user?.firstname}</h4>
						{/* <p>UX / UI Designer</p> */}
					  </div>
					 
					  <Dropdown className="dropdown ms-auto">
						<Dropdown.Toggle
						  variant="primary"
						  className="btn btn-primary light sharp i-false"
						  data-toggle="dropdown"
						  aria-expanded="true"
						>
						  <svg
							xmlns="http://www.w3.org/2000/svg"
							//    xmlns:xlink="http://www.w3.org/1999/xlink"
							width="18px"
							height="18px"
							viewBox="0 0 24 24"
							version="1.1"
						  >
							<g
							  stroke="none"
							  strokeWidth="1"
							  fill="none"
							  fillRule="evenodd"
							>
							  <rect x="0" y="0" width="24" height="24"></rect>
							  <circle fill="#000000" cx="5" cy="12" r="2"></circle>
							  <circle fill="#000000" cx="12" cy="12" r="2"></circle>
							  <circle fill="#000000" cx="19" cy="12" r="2"></circle>
							</g>
						  </svg>
						</Dropdown.Toggle>
						<Dropdown.Menu className="dropdown-menu dropdown-menu-right">
						  <Dropdown.Item className="dropdown-item">
							<i className="fa fa-user-circle text-primary me-2" />
							View profile
						  </Dropdown.Item>
						  <Dropdown.Item className="dropdown-item">
							<i className="fa fa-users text-primary me-2" />
							Add to close friends
						  </Dropdown.Item>
						  <Dropdown.Item className="dropdown-item">
							<i className="fa fa-plus text-primary me-2" />
							Add to group
						  </Dropdown.Item>
						  <Dropdown.Item className="dropdown-item">
							<i className="fa fa-ban text-primary me-2" />
							Block
						  </Dropdown.Item>
						</Dropdown.Menu>
					  </Dropdown>
					</div>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		  <div className="row">
			<div className="col-xl-4">
				<div className="row">
					<div className="col-lg-12">
						<div className="card">
							<div className="card-body">
								<div className="profile-statistics">
									<div className="text-center">
										<div className="row">
											<div className="col">
												<h3 className="m-b-0">150</h3><span>Follower</span>
											</div>
											<div className="col">
												<h3 className="m-b-0">140</h3> <span>Place Stay</span>
											</div>
											<div className="col">
												<h3 className="m-b-0">45</h3> <span>Reviews</span>
											</div>
										</div>
										<div className="mt-4">
											<Link	to="/post-details"	className="btn btn-primary mb-1 me-1">Follow</Link>
											<Button as="a" href="#" className="btn btn-primary mb-1 ms-1" onClick={() => dispatch({type:'sendMessage'})}>Send Message</Button>
										</div>
									</div>
								  
								</div>
							</div>
						</div>
					</div>	
					<div className="col-lg-12">
						<div className="card">
							<div className="card-header border-0 pb-0">
								<h5 className="text-primary">Today Highlights</h5>
							</div>	
							<div className="card-body pt-3"	>	
								<div className="profile-blog ">
									<img  src={profile01}  alt="profile" className="img-fluid  mb-4 w-100 " />
									<Link to="/post-details"> <h4>Darwin Creative Agency Theme</h4> </Link>
									<p className="mb-0">
										A small river named Duden flows by their place and supplies
										it with the necessary regelialia. It is a paradisematic
										country, in which roasted parts of sentences fly into your
										mouth.
									</p>
								</div>
							</div>	
						</div>
					</div>
					<div className="col-lg-12">
						<div className="card">
							<div className="card-header border-0 pb-0">
								<h5 className="text-primary ">Interest</h5>
							</div>
							<div className="card-body pt-3">
								<div className="profile-interest ">	
									<LightGallery
										onInit={onInit}
										speed={500}
										plugins={[lgThumbnail, lgZoom]}
										elementClassNames="row sp4"
									>
										
										{galleryBlog.map((item,index)=>(
										<div data-src={item.image} className="col-lg-4 col-xl-4 col-sm-4 col-6 int-col mb-1" key={index}>
											<img src={item.image} style={{width:"100%"}} alt="gallery"/>
										</div>
										))}
									</LightGallery>										
								</div>
							</div>	
						</div>
					</div>	
					<div className="col-lg-12">
						<div className="card">
							<div className="card-header border-0 pb-0">
								<h5 className="text-primary">Our Latest News</h5>
							</div>	
							<div className="card-body pt-3">
								<div className="profile-news">
								  <div className="media pt-3 pb-3">
									<img src={profile05} alt="" className="me-3 rounded" width={75}/>
									<div className="media-body">
										<h5 className="m-b-5">
											<Link to="/post-details" className="text-black">
												Collection of textile samples
											</Link>
										</h5>
										<p className="mb-0">I shared this on my fb wall a few months back, and I thought. </p>
									</div>
								  </div>
								  <div className="media pt-3 pb-3">
									<img src={profile06} alt=""  className="me-3 rounded" width={75}/>
									<div className="media-body">
										<h5 className="m-b-5">
											<Link to="/post-details" className="text-black">
											Collection of textile samples
											</Link>
										</h5>
										<p className="mb-0">
											I shared this on my fb wall a few months back, and I
											thought.
										</p>
									</div>
								  </div>
								  <div className="media pt-3 ">
									<img src={profile07} alt="" className="me-3 rounded" width={75} />
									<div className="media-body">
										<h5 className="m-b-5">
											<Link to="/post-details" className="text-black">
												Collection of textile samples
											</Link>
										</h5>
										<p className="mb-0">
											I shared this on my fb wall a few months back, and I thought.
										</p>
									</div>
								  </div>
								</div>
							</div>	
						</div>
					</div>	
				</div>	
			</div>	
			<div className="col-xl-8">
			  <div className="card">
				<div className="card-body">
				  <div className="profile-tab">
					<div className="custom-tab-1">
						<Tab.Container defaultActiveKey='About'>					
							<Nav as='ul' className="nav nav-tabs">
								<Nav.Item as='li' className="nav-item">
									<Nav.Link to="#about-me"  eventKey='About'>About Me</Nav.Link>
								</Nav.Item>
								<Nav.Item as='li' className="nav-item">
									<Nav.Link to="#my-posts" eventKey='Posts'>Posts</Nav.Link>
								</Nav.Item>
								{/* <Nav.Item as='li' className="nav-item">
									<Nav.Link to="#about-me"  eventKey='About'>Edit</Nav.Link>
								</Nav.Item> */}
								<Nav.Item as='li' className="nav-item">
									<Nav.Link to="#profile-settings" eventKey='Setting'>Setting</Nav.Link>
								</Nav.Item>
							</Nav>
							<Tab.Content>
							<Tab.Pane id="about-me" eventKey='About'>
								<div className="profile-personal-info">
									<div className="d-flex align-items-center mb-4">
									<i className="fa fa-user-circle text-primary me-2" style={{fontSize: '24px'}}></i>
									<h4 className="text-primary mb-0">Informations Personnelles</h4>
									</div>
									
									<div className="info-card mb-4 p-4 rounded-3" style={{backgroundColor: '#f8f9fa'}}>
									<div className="row g-3">
										{/* Nom Complet */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-user me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Nom Complet</h6>
											<p className="mb-0 fw-medium">{user?.lastname} {user?.firstname}</p>
											</div>
										</div>
										</div>

										{/* Email */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-envelope me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Email</h6>
											<p className="mb-0 fw-medium">{user?.email || 'Non spécifié'}</p>
											</div>
										</div>
										</div>

										{/* Téléphone */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-phone me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Téléphone</h6>
											<p className="mb-0 fw-medium">{user?.phoneNumber || 'Non spécifié'}</p>
											</div>
										</div>
										</div>

										{/* Date de naissance */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-calendar me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Date de naissance</h6>
											<p className="mb-0 fw-medium">
												{user?.dateOfBirth ? new Date(user.dateOfBirth).toLocaleDateString() : 'Non spécifiée'}
											</p>
											</div>
										</div>
										</div>

										{/* Genre */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-venus-mars me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Genre</h6>
											<p className="mb-0 fw-medium">
												{user?.gender === 'MALE' ? 'Homme' : user?.gender === 'FEMALE' ? 'Femme' : 'Non spécifié'}
											</p>
											</div>
										</div>
										</div>

										{/* Pays */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-globe me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Pays</h6>
											<p className="mb-0 fw-medium">{user?.country || 'Non spécifié'}</p>
											</div>
										</div>
										</div>

										{/* Objectif */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-bullseye me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Objectif</h6>
											<p className="mb-0 fw-medium">
												{user?.userGoal?.weightGoal?.name || 'Non spécifié'}
											</p>
											</div>
										</div>
										</div>

										{/* Poids initial */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-weight me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Poids initial</h6>
											<p className="mb-0 fw-medium">
												{user?.standardInitialWeight ? `${user.standardInitialWeight} kg` : 'Non spécifié'}
											</p>
											</div>
										</div>
										</div>

										{/* Taille */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-ruler-vertical me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Taille</h6>
											<p className="mb-0 fw-medium">
												{user?.height ? `${user.height} cm` : 'Non spécifiée'}
											</p>
											</div>
										</div>
										</div>

										{/* Niveau d'activité */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-running me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Niveau d'activité</h6>
											<p className="mb-0 fw-medium">
												{user?.activityLevel ? 
												user.activityLevel === 'SEDENTARY' ? 'Sédentaire' :
												user.activityLevel === 'MODERATE' ? 'Légèrement actif' :
												user.activityLevel === 'MODERATELY_ACTIVE' ? 'Modérément actif' :
												user.activityLevel === 'VERY_ACTIVE' ? 'Très actif' : 
												user.activityLevel : 'Non spécifié'}
											</p>
											</div>
										</div>
										</div>

										{/* Accès à l'équipement */}
										<div className="col-md-6">
										<div className="d-flex align-items-center mb-3">
											<i className="fa fa-dumbbell me-3 text-muted"></i>
											<div>
											<h6 className="mb-0 text-muted small">Accès à l'équipement</h6>
											<p className="mb-0 fw-medium">
												{user?.equipmentAccess ? 'Oui' : 'Non'}
											</p>
											</div>
										</div>
										</div>
									</div>
									</div>

									{/* Section Langues */}
									<div className="mt-4">
									<h5 className="text-muted mb-3">Langues</h5>
									<div className="d-flex flex-wrap gap-3">
										<span className="badge bg-light text-dark p-2 d-flex align-items-center">
										<i className="flag-icon flag-icon-fr me-2"></i>
										Français
										</span>
										<span className="badge bg-light text-dark p-2 d-flex align-items-center">
										<i className="flag-icon flag-icon-us me-2"></i>
										English
										</span>
									</div>
									</div>
								</div>
								</Tab.Pane>
								<Tab.Pane id="my-posts"  eventKey='Posts'>
									<div className="my-post-content pt-3">
										<div className="post-input">
											<textarea name="textarea" id="textarea" cols={30} rows={5} className="form-control bg-transparent" placeholder="Please type what you want...."defaultValue={""}/>
											<Link to="/app-profile" className="btn btn-primary light px-3 me-2"  onClick={() => dispatch({type:'linkModal'})}>
												<i className="fa fa-link m-0" />{" "}
											</Link>
											{/* Modal */}
											
											<Link to={"#"} className="btn btn-primary light px-3 me-1"  data-target="#cameraModal" onClick={() => dispatch({type:'cameraModal'})}>
												<i className="fa fa-camera m-0" />{" "}
											</Link>
											{/* Modal */}
											
											<Link to={"#"} className="btn btn-primary ms-1" data-target="#postModal" onClick={() => dispatch({type:'postModal'})}>Post</Link>
											{/* Modal */}											
										</div>	
										<div className="profile-uoloaded-post border-bottom-1 pb-5">
											<img src={profile08} alt="" className="img-fluid w-100 rounded" />
											<Link className="post-title" to="/post-details">
												<h3 className="text-black">Collection of textile samples lay spread</h3>
											</Link>
											<p>
												A wonderful serenity has take possession of my entire soul like these sweet morning of spare which enjoy whole heart.A wonderful serenity has take 
												possession of my entire soul like these sweet morning of spare which enjoy whole heart.
											</p>
											<button className="btn btn-primary me-2">
												<span className="me-2"> <i className="fa fa-heart" /> </span>Like 
											</button>
											<button className="btn btn-secondary" onClick={() => dispatch({type:'replyModal'})}>
												<span className="me-2"> <i className="fa fa-reply" /></span>Reply
											</button>
										</div>
										<div className="profile-uoloaded-post border-bottom-1 pb-5">
											<img src={profile09} alt="" className="img-fluid w-100 rounded" />
											<Link className="post-title" to="/post-details">
												<h3 className="text-black">Collection of textile samples lay spread</h3>
											</Link>
											<p>
												A wonderful serenity has take possession of my
												entire soul like these sweet morning of spare which
												enjoy whole heart.A wonderful serenity has take
												possession of my entire soul like these sweet
												morning of spare which enjoy whole heart.
											</p>
											<button className="btn btn-primary me-2">
												<span className="me-2"> <i className="fa fa-heart" /> </span>Like
											</button>
											<button className="btn btn-secondary" onClick={() => dispatch({type:'replyModal'})}>
												<span className="me-2">  <i className="fa fa-reply" /></span>Reply
											</button>
										</div>
										<div className="profile-uoloaded-post pb-3">
											<img src={profile08} alt="" className="img-fluid  w-100 rounded" />
											<Link className="post-title" to="/post-details">
												<h3 className="text-black">Collection of textile samples lay spread</h3>
											</Link>
											<p>
												A wonderful serenity has take possession of my
												entire soul like these sweet morning of spare which
												enjoy whole heart.A wonderful serenity has take
												possession of my entire soul like these sweet
												morning of spare which enjoy whole heart.
											</p>
											<button className="btn btn-primary me-2">
												<span className="me-2"><i className="fa fa-heart" /></span>Like
											</button>
											<button className="btn btn-secondary" onClick={() => dispatch({type:'replyModal'})}>
												<span className="me-2"> <i className="fa fa-reply" /></span>Reply
											</button>
										</div>
										
									</div>
								</Tab.Pane>
								
								<Tab.Pane id="profile-settings" eventKey="Setting">
									<div className="pt-3">
										<div className="settings-form">
										<div className="card shadow-sm border-0">
											<div className="card-body p-4">
											<h4 className="text-primary mb-4">
												<i className="fas fa-user-edit me-2"></i>
												Mise à jour des informations personnelles
											</h4>
											{updateSuccess && (
											<div className="alert alert-success alert-dismissible fade show" role="alert">
												<i className="fas fa-check-circle me-2"></i>
												{updateSuccess}
												<button 
												type="button" 
												className="btn-close" 
												onClick={() => setUpdateSuccess(false)}
												aria-label="Close"
												></button>
											</div>
											)}

											{updateError && (
											<div className="alert alert-danger alert-dismissible fade show" role="alert">
												<i className="fas fa-exclamation-circle me-2"></i>
												{updateError}
												<button 
												type="button" 
												className="btn-close" 
												onClick={() => setUpdateError(null)}
												aria-label="Close"
												></button>
											</div>
											)}
											
											<form onSubmit={handleSubmit} className="mb-5">
												<div className="row g-4">
												{/* Section Photo de profil */}
												<div className="col-12 text-center mb-4">
													<div className="position-relative d-inline-block">
													<div
														className="profile-photo-upload"
														onClick={() => fileInputRef.current.click()}
														style={{ 
														cursor: "pointer",
														position: "relative",
														display: "inline-block"
														}}
													>
														{userData1.photo ? (
														<img
															src={userData1.photo}
															alt="Profil"
															className="rounded-circle shadow"
															style={{ 
															width: "150px", 
															height: "150px",
															objectFit: "cover",
															border: "3px solid #fff",
															boxShadow: "0 0 10px rgba(0,0,0,0.1)"
															}}
														/>
														) : (
														<div 
															className="bg-light rounded-circle d-flex align-items-center justify-content-center"
															style={{ 
															width: "150px", 
															height: "150px",
															border: "2px dashed #dee2e6"
															}}
														>
															<i className="fas fa-camera fs-1 text-muted"></i>
														</div>
														)}
														<div className="position-absolute bottom-0 end-0 bg-primary rounded-circle p-2">
														<i className="fas fa-pencil-alt text-white"></i>
														</div>
														{isUploading && (
														<div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-circle">
															<Spinner animation="border" variant="light" />
														</div>
														)}
													</div>
													<input
														type="file"
														name="photo"
														accept="image/*"
														onChange={handleFileChange}
														ref={fileInputRef}
														style={{ display: "none" }}
													/>
													<p className="text-muted mt-2 mb-0">Cliquez pour changer la photo</p>
													</div>
												</div>

												{/* Informations de base */}
												<div className="col-md-6">
													<div className="form-floating mb-3">
													<input
														type="text"
														name="firstname"
														id="firstname"
														value={userData1?.firstname || ""}
														onChange={handleChange}
														className="form-control"
														placeholder="Prénom"
													/>
													<label htmlFor="firstname" className="text-muted">
														<i className="fas fa-user me-2 text-primary"></i>Prénom
													</label>
													</div>
												</div>

												<div className="col-md-6">
													<div className="form-floating mb-3">
													<input
														type="text"
														name="lastname"
														id="lastname"
														value={userData1?.lastname || ""}
														onChange={handleChange}
														className="form-control"
														placeholder="Nom"
													/>
													<label htmlFor="lastname" className="text-muted">
														<i className="fas fa-user me-2 text-primary"></i>Nom
													</label>
													</div>
												</div>

												<div className="col-md-6">
													<div className="form-floating mb-3">
													<input
														type="tel"
														name="phoneNumber"
														id="phoneNumber"
														value={userData1?.phoneNumber || ""}
														onChange={handleChange}
														className="form-control"
														placeholder="Téléphone"
													/>
													<label htmlFor="phoneNumber" className="text-muted">
														<i className="fas fa-phone me-2 text-primary"></i>Téléphone
													</label>
													</div>
												</div>
												</div>

												<div className="d-flex justify-content-end mt-4">
												<button 
													className="btn btn-primary px-4 py-2 d-flex align-items-center" 
													type="submit" 
													disabled={isLoading}
												>
													{isLoading ? (
													<>
														<Spinner as="span" animation="border" size="sm" className="me-2" />
														Mise à jour en cours...
													</>
													) : (
													<>
														<i className="fas fa-save me-2"></i>
														Enregistrer les modifications
													</>
													)}
												</button>
												</div>
											</form>

											{/* Section Informations importantes */}
											<div className="mt-5 pt-4 border-top">
												<h5 className="text-primary mb-4">
												<i className="fas fa-info-circle me-2"></i>
												Informations complémentaires
												</h5>
												{updateSuccess && (
    <div className="alert alert-success alert-dismissible fade show" role="alert">
      <i className="fas fa-check-circle me-2"></i>
      {updateSuccess}
      <button 
        type="button" 
        className="btn-close" 
        onClick={() => setUpdateSuccess(false)}
        aria-label="Close"
      ></button>
    </div>
  )}

  {updateError && (
    <div className="alert alert-danger alert-dismissible fade show" role="alert">
      <i className="fas fa-exclamation-circle me-2"></i>
      {updateError}
      <button 
        type="button" 
        className="btn-close" 
        onClick={() => setUpdateError(null)}
        aria-label="Close"
      ></button>
    </div>
  )}
												
												<form onSubmit={handleSubmit1}>
												<div className="row g-4">
													<div className="col-md-6">
													<div className="form-floating mb-3">
														<select
														name="gender"
														id="gender"
														value={userData.gender}
														onChange={handleChange}
														className="form-select"
														>
														<option value="MALE">Homme</option>
														<option value="FEMALE">Femme</option>
														</select>
														<label htmlFor="gender" className="text-muted">
														<i className="fas fa-venus-mars me-2 text-primary"></i>Genre
														</label>
													</div>
													</div>

													<div className="col-md-6">
													<div className="form-floating mb-3">
														<input
														type="text"
														name="country"
														id="country"
														value={userData.country}
														onChange={handleChange}
														className="form-control"
														placeholder="Pays"
														/>
														<label htmlFor="country" className="text-muted">
														<i className="fas fa-globe me-2 text-primary"></i>Pays
														</label>
													</div>
													</div>

													<div className="col-md-6">
													<div className="form-floating mb-3">
														<select
														name="su_activityLevel"
														id="activityLevel"
														value={userData.su_activityLevel}
														onChange={handleChange}
														className="form-select"
														>
														<option value="SEDENTARY">Sédentaire</option>
														<option value="MODERATE">Légèrement actif</option>
														<option value="MODERATELY_ACTIVE">Modérément actif</option>
														<option value="VERY_ACTIVE">Très actif</option>
														</select>
														<label htmlFor="activityLevel" className="text-muted">
														<i className="fas fa-running me-2 text-primary"></i>Niveau d'activité
														</label>
													</div>
													</div>

													<div className="col-md-6">
													<div className="form-floating mb-3">
														<input
														type="number"
														name="su_initialWeight"
														id="initialWeight"
														value={userData.su_initialWeight}
														onChange={handleChange}
														className="form-control"
														placeholder="Poids initial"
														step="0.1"
														/>
														<label htmlFor="initialWeight" className="text-muted">
														<i className="fas fa-weight me-2 text-primary"></i>Poids initial (kg)
														</label>
													</div>
													</div>

													<div className="col-md-6">
													<div className="form-floating mb-3">
														<input
														type="number"
														name="su_height"
														id="height"
														value={userData.su_height}
														onChange={handleChange}
														className="form-control"
														placeholder="Taille"
														/>
														<label htmlFor="height" className="text-muted">
														<i className="fas fa-ruler-vertical me-2 text-primary"></i>Taille (cm)
														</label>
													</div>
													</div>
												</div>

												<div className="d-flex justify-content-between align-items-center mt-4">
													<div className="form-check form-switch">
													<input
														type="checkbox"
														className="form-check-input"
														id="changePasswordToggle"
														checked={showChangePassword}
														onChange={() => setShowChangePassword(!showChangePassword)}
													/>
													<label className="form-check-label" htmlFor="changePasswordToggle">
														<i className="fas fa-key me-2 text-primary"></i>
														Changer le mot de passe
													</label>
													</div>

													<button 
													className="btn btn-primary px-4 py-2" 
													type="submit" 
													disabled={isLoading}
													>
													{isLoading ? (
														<>
														<Spinner as="span" animation="border" size="sm" className="me-2" />
														Enregistrement...
														</>
													) : (
														'Mettre à jour les informations'
													)}
													</button>
												</div>
												</form>

												{/* Section changement de mot de passe */}
												{showChangePassword && (
												<div className="mt-4 pt-4 border-top">
													<h6 className="text-primary mb-3">
													<i className="fas fa-lock me-2"></i>
													Changer le mot de passe
													</h6>
													<ChangePassword onSuccess={() => {
													// Masquer la section après un changement réussi
													setShowChangePassword(false);
													}} />
												</div>
												)}
											</div>
											</div>
										</div>
										</div>
									</div>
									</Tab.Pane>

							</Tab.Content>	
						</Tab.Container>		
					</div>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		  {/* send Modal */}
			  <Modal className="modal fade" show={state.sendMessage} onHide={()=>dispatch({type:'sendMessage'})} centered>
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Send Message</h5>
						<Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => dispatch({type:'sendMessage'})}>
							
						</Button>
					</div>
					<div className="modal-body">
						<form className="comment-form" onSubmit={(e) => { e.preventDefault(); dispatch({type:'sendMessage'}); }}>
							<div className="row">
								<div className="col-lg-6">
									<div className="form-group mb-3">
										<label htmlFor="author" className="text-black font-w600">  Name <span className="required">*</span> </label>
										<input type="text" className="form-control" defaultValue="Author" name="Author" placeholder="Author" />
									</div>
								</div>
								<div className="col-lg-6">
									<div className="form-group mb-3">
										<label htmlFor="email" className="text-black font-w600"> Email <span className="required">*</span></label>
										<input type="text" className="form-control" defaultValue="Email" placeholder="Email" name="Email"/>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="form-group mb-3">
										<label htmlFor="comment" className="text-black font-w600">Comment</label>
										<textarea rows={4} className="form-control" name="comment" placeholder="Comment" defaultValue={""}/>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="form-group mb-3">
										<input type="submit" value="Post Comment" className="submit btn btn-primary" name="submit"/>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</Modal>
		  {/* Post Modal */}
			  <Modal show={state.post} className="modal fade" id="postModal" onHide={() => dispatch({type:'postModal'})} centered>
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Post</h5>
						<Button variant=""  type="button" className="close" data-dismiss="modal" onClick={() => dispatch({type:'postModal'})} >
							<span>×</span>
						</Button>
						
					</div>
					<div className="modal-body">
						<textarea name="textarea" id="textarea" cols={30} rows={5} className="form-control mb-2 bg-transparent" placeholder="Please type what you want...." defaultValue={""}/>
						<Link className="btn btn-primary btn-rounded mt-1" to="/app-profile">Post</Link>
					</div>
				</div>
			</Modal>
			 {/* Link Modal */}
			  <Modal show={state.link}  className="modal fade post-input" id="linkModal" onHide={() => dispatch({type:'linkModal'})} centered>
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Social Links</h5>
						<button type="button" className="close btn" data-dismiss="modal" onClick={() => dispatch({type:'linkModal'})}>
							<span>×</span>
						</button>
					</div>
					<div className="modal-body">
						<Link className="btn-social me-1 facebook" to="/app-profile"><i className="fab fa-facebook-f" /></Link>
						<Link className="btn-social me-1 google-plus" to="/app-profile"> <i className="fab fa-google-plus-g" /></Link>
						<Link className="btn-social me-1 linkedin" to="/app-profile"><i className="fab fa-linkedin-in" /></Link>
						<Link className="btn-social me-1 instagram" to="/app-profile"> <i className="fab fa-instagram" /></Link>
						<Link className="btn-social me-1 twitter" to="/app-profile"><i className="fab fa-twitter" /></Link>
						<Link className="btn-social me-1 youtube" to="/app-profile"><i className="fab fa-youtube" /></Link>
						<Link className="btn-social whatsapp" to="/app-profile"><i className="fab fa-whatsapp" /></Link>
					</div>
				</div>
			</Modal>
			 {/* Camera Modal */}
			  <Modal show={state.camera}  className="modal fade" id="cameraModal" onHide={() => dispatch({type:'cameraModal'})} centered>
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Upload images</h5>
						<button type="button" className="btn close" data-dismiss="modal" onClick={() => dispatch({type:'cameraModal'})}>
							<span>×</span>
						</button>
					</div>
					<div className="modal-body">
						<div className="input-group mb-3 flex-nowrap">
							<span className="input-group-text rounded-sm">Upload</span>
							<div className="form-file border-left-end overflow-hidden">
								<input type="file" className="form-file-input form-control" />
							</div>
						</div>
					</div>
				</div>
			</Modal>
			 {/* Reply Modal */}
			  <Modal   show={state.reply}  className="modal fade" id="replyModal" onHide={()=>dispatch({type:'replyModal'})} centered>
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Post Reply</h5>
						<button type="button" className="btn close"  onClick={() => dispatch({type:'replyModal'})}><span>×</span></button>
					</div>
					<div className="modal-body">
						<form>
							<textarea className="form-control" rows="4">Message</textarea>
						</form>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-danger light"  onClick={() => dispatch({type:'replyModal'})}>Close</button>
						<button type="button" className="btn btn-primary">Reply</button>
					</div>
				</div>
			</Modal>
		</Fragment>



	  );

};

export default AppProfile;
